module.exports = __webpack_public_path__ + "officialStatic/img/trusteeship-con.2f49bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/trusteeship-con.png
// module id = YPZP
// module chunks = 0